export default __webpack_public_path__ + "static/media/saved_results.b85d2baf.png";